export default {
      id: "region-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#region",
      toString: function () {
        return this.url;
      }
    }